import React from "react";

export default function Fail() {
  return <div>Fail</div>;
}
